import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const checkboxStyle = css`
    width: 16px;
    height: 16px;

    .sds-checkbox-wrapper > & span.rc-checkbox-inner {
        width: 16px;
        height: 16px;
        border-color: ${Colors.Black.V50};
    }

    .sds-checkbox-wrapper > & span.rc-checkbox-inner:after {
        top: 1px;
        left: 4px;
        width: 5px;
        height: 8px;
    }
`;
